import { render, staticRenderFns } from "./editGbody200.vue?vue&type=template&id=73a1536e&"
import script from "./editGbody200.vue?vue&type=script&lang=js&"
export * from "./editGbody200.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports